import BaseRepository from "core/repository/base.repository";
import { CompanyService } from "core/service";
import { CompanyPersistence } from "core/persistence";

class CompanyRepository extends BaseRepository {
  syncable = false;

  resourceName = () => "empresas";

  getEntityIdentifier = () => "company";

  getPersistenceProvider = () => CompanyPersistence;

  getServiceProvider = () => CompanyService;

  getCnpjInfo = cnpj => this.mService.getCnpjInfo(cnpj);

  getZipcodeInfo = zipcode => this.mService.getZipcodeInfo(zipcode);

  async getLastUpdated(uuid) {
    return await this.mPersistence.lastUpdated("uuid", uuid);
  }

  async searchByName(name) {
    const currentUser = await this.mRuntime.get("currentUser");

    const filters = [];

    if (currentUser.allowed_companies_uuids) {
      currentUser.allowed_companies_uuids.forEach(uuid =>
        filters.push({
          connector: "OR",
          field: "company_uuid",
          operation: "EQ",
          value: uuid
        })
      );
    }

    filters.push({ field: "deleted", operation: "EQ", value: false });
    filters.push({ field: "name", operation: "LIKE", value: name });
    filters.push({
      field: "account_uuid",
      operation: "EQ",
      value: currentUser.account_uuid
    });

    const companies = [];
    const success = await this.mPersistence.stream(filters, category =>
      companies.push(category)
    );

    return success ? { success, data: companies } : { success };
  }

  async getCompanies({ filters = [], order = [], pagination = {} }) {
    const serviceResult = await this.mService.getCompanies({
      filters,
      order,
      pagination
    });

    if (serviceResult.success) {
      return {
        success: true,
        results: serviceResult.data,
        total: serviceResult.headers["total"],
        perPage: serviceResult.headers["per-page"]
      };
    }

    return {
      success: false,
      fatal: serviceResult.fatal,
      errors: serviceResult.errors
    };
  }

  async toggleBlockCompanies(params) {
    return await this.mService.toggleBlockCompanies(params);
  }

  async importCompanies(params) {
    return await this.mService.importCompanies(params);
  }

  async cloneCompanySellables(params) {
    return await this.mService.cloneCompanySellables(params);
  }

  async validateInfo(id) {
    return this.mService.validateInfo(id);
  }

  async validateInfoStatus(id) {
    return this.mService.validateInfoStatus(id);
  }

  async validateSellables(id) {
    return this.mService.validateSellables(id);
  }

  async validateSellablesNfce(id) {
    return this.mService.validateSellablesNfce(id);
  }
}

export default new CompanyRepository();



// WEBPACK FOOTER //
// ./src/core/repository/company.repository.js